// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { AdminStatus, IAdmin } from '@/models/admins.model';

// Components
import { Button } from '@/ui';
import { StyledActionsWrap, StyledIconWrap } from './AdminTableActionsStyles';
import { TrashIcon } from '@/icons';

// Helpers
import { getEntityId } from '@/utils';

type TAdminTableActions = {
  record: IAdmin;
  updateAdminStatus: (id: string, status: AdminStatus) => void;
  deleteAdmin?: (id: string) => void;
};

const AdminTableActions = ({ record, updateAdminStatus, deleteAdmin }: TAdminTableActions) => {
  const { t } = useTranslation(['admins']);
  const id = getEntityId(record?.PK);
  const isActive = record.status === AdminStatus.ACTIVE;

  const onStatusUpdate = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const newStatus = isActive ? AdminStatus.DEACTIVATED : AdminStatus.ACTIVE;
    updateAdminStatus(id, newStatus);
  };

  const onDelete = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    deleteAdmin?.(id);
  };

  return (
    <StyledActionsWrap>
      <Button block size="small" type={isActive ? 'default' : 'link'} onClick={onStatusUpdate}>
        {t(isActive ? 'admin_actions_deactivate' : 'admin_actions_activate')}
      </Button>
      <StyledIconWrap onClick={onDelete}>
        <TrashIcon />
      </StyledIconWrap>
    </StyledActionsWrap>
  );
};

export default AdminTableActions;
